<template>
    <div class="all">
      <div class="all_top">
        <img src="../assets/logo.jpg" alt="" @click="$router.push({path:'/'})">
        <span>欢迎注册</span>
      </div>
    </div>
</template>

<script>
    export default {
        name: "login_top"
    }
</script>

<style scoped lang="less">
 @import "css/login_top1";
</style>



// WEBPACK FOOTER //
// src/assembly/login_top1.vue